module.exports = __webpack_public_path__ + "static/media/column2.620d14a9.png";